export class Credential {
    constructor(
        public role: string,
        public email: string,
        public password: string
    ){}
}


// WEBPACK FOOTER //
// ./src/common/modules/user/models/Credential.ts